import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowBack as IconVolver, Search as IconSearch } from "@mui/icons-material";
import { Button, FormControl, Grid, InputLabel, MenuItem, Select, Typography, Table, TableBody, TableCell, TableHead, TableRow, Box } from "@mui/material";

import { useFiltroFilial } from "../../hooks/useFiltroFilial";
import FiltroFilial from "../../components/common/FiltroFilial";
import * as terapiaService from "../../services/terapiaService";
import * as terapiaPlanService from "../../services/terapiaPlanService";

const NOMBRES_MES = ["", "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const Trimestral = () => {
    const { filiales, idFilial, setIdFilial, bloqueado } = useFiltroFilial();

    const [idTerapia, setIdTerapia] = useState(0);
    const [listTerapias, setListTerapias] = useState([]);
    const [idTerapiaPlan, setIdTerapiaPlan] = useState(0);
    const [listPlanes, setListPlanes] = useState([]);
    const [reporte, setReporte] = useState(null);
    const [cargando, setCargando] = useState(false);

    const fetchTerapias = useCallback(async (filial) => {
        const data = await terapiaService.getsTerapiaResumenView({
            idFilial: filial || 0, member: "", therapist: "", idEstado: 2, idTerapeuta: 0,
        }).catch((err) => { console.log("Err: ", err); return []; });
        setListTerapias(data || []);
        setIdTerapia(0);
        setIdTerapiaPlan(0);
        setListPlanes([]);
        setReporte(null);
    }, []);

    const fetchPlanes = useCallback(async (idT) => {
        if (!idT || idT <= 0) { setListPlanes([]); return; }
        const data = await terapiaPlanService.getsTerapiaPlanResumenView({
            idFilial: 0, member: "", therapist: "", idEstadoVigencia: 0, idEstado: 0, idTerapeuta: 0,
        }).catch((err) => { console.log("Err: ", err); return []; });
        // Solo planes trimestrales de la terapia seleccionada.
        setListPlanes((data || []).filter((row) =>
            row.idTerapiaPlan != null && row.idTerapia === idT && row.periodicidad === "Trimestral"));
        setIdTerapiaPlan(0);
        setReporte(null);
    }, []);

    useEffect(() => { fetchTerapias(idFilial); }, [idFilial, fetchTerapias]);

    const fetchReporte = useCallback(async (idPlan) => {
        if (!idPlan || idPlan <= 0) { setReporte(null); return; }
        setCargando(true);
        const data = await terapiaPlanService.getsReporteTrimestral(idPlan)
            .catch((err) => { console.log("Err: ", err); return null; });
        setReporte(data);
        setCargando(false);
    }, []);

    const sesionesDe = (mes) => {
        const m = reporte?.meses?.find((x) => x.mes === mes);
        return m ? m.sesiones : 0;
    };

    const renderMes1 = () => {
        const n = sesionesDe(1);
        return (
            <>
                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                    Sesión 1
                    <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                        Plan personal<br />
                        - Entrevista a padres.<br />
                        - Definición y objetivos.<br />
                        - Propuestas de intervención
                    </Box>
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                    Sesión 2
                    <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                        Vinculo/Rastreo<br />
                        Se establecio un vinculo de confianza mediante la observacion, se cotejan habilidades y dificultades, para definir la linea base de intervención (adaptado a la edad)
                    </Box>
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                    Sesión 3 a la {n}
                    <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                        Actividades con el usuario
                    </Box>
                </TableCell>
            </>
        );
    };

    const renderMesSimple = (mes) => {
        const n = sesionesDe(mes);
        return (
            <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                Sesión 1 a {n}
                <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                    Actividades con el usuario
                </Box>
            </TableCell>
        );
    };

    const renderMesReporte = (mes) => {
        const n = sesionesDe(mes);
        return (
            <>
                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                    Sesión 1 a {n > 0 ? n - 1 : 0}
                    <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                        Actividades con el usuario
                    </Box>
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold", fontSize: 11 }}>
                    Sesión {n}
                    <Box sx={{ fontWeight: "normal", fontSize: 10, mt: 0.5 }}>
                        Reporte Trimestral<br />
                        - Desarrollo y seguimiento.<br />
                        - Ajustes y objetivos.<br />
                        - Act. plan personal.<br />
                        - Psicoeducacion familiar.
                    </Box>
                </TableCell>
            </>
        );
    };

    const renderFilaMeses = (meses) => (
        <TableRow>
            {meses.map((m) => {
                if (m === 1) return <React.Fragment key={m}>{renderMes1()}</React.Fragment>;
                if (m === 3 || m === 6 || m === 9 || m === 12) return <React.Fragment key={m}>{renderMesReporte(m)}</React.Fragment>;
                return <React.Fragment key={m}>{renderMesSimple(m)}</React.Fragment>;
            })}
        </TableRow>
    );

    const renderCabeceraMeses = (meses) => (
        <TableRow>
            {meses.map((m) => (
                <TableCell key={m} align="center" colSpan={m === 1 ? 3 : (m === 3 || m === 6 || m === 9 || m === 12 ? 2 : 1)}
                    sx={{ fontWeight: "bold", fontSize: 12 }}>
                    MES {m}
                </TableCell>
            ))}
        </TableRow>
    );

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Button component={Link} to="/reporte" startIcon={<IconVolver />} size="small"
                    sx={{ marginBottom: 1, paddingLeft: 0 }}>
                    Volver a Reportes
                </Button>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>Reporte Trimestral</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}>
                        <FiltroFilial
                            filiales={filiales}
                            idFilial={idFilial}
                            bloqueado={bloqueado}
                            onChange={(nuevo) => {
                                setIdFilial(nuevo);
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                        <FormControl fullWidth size="small">
                            <InputLabel htmlFor="input-terapia" shrink>Terapia</InputLabel>
                            <Select
                                native
                                label="Terapia"
                                value={idTerapia}
                                onChange={(event) => {
                                    const t = parseInt(event.target.value);
                                    setIdTerapia(t);
                                    fetchPlanes(t);
                                }}
                                inputProps={{ name: "idTerapia", id: "input-terapia" }}
                                size="small"
                            >
                                <option value={0}>{"(Seleccione)"}</option>
                                {listTerapias.map((row) => (
                                    <option key={row.idTerapia} value={row.idTerapia}>
                                        {(row.fechaInicio ? new Date(row.fechaInicio).toLocaleDateString("es-PE") : "")}
                                        {" - " + (row.participante || "")}
                                        {" - " + (row.terapeuta || "")}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel htmlFor="input-plan" shrink>Plan de Terapia</InputLabel>
                            <Select
                                native
                                label="Plan de Terapia"
                                value={idTerapiaPlan}
                                onChange={(event) => {
                                    const plan = parseInt(event.target.value);
                                    setIdTerapiaPlan(plan);
                                    fetchReporte(plan);
                                }}
                                inputProps={{ name: "idTerapiaPlan", id: "input-plan" }}
                                size="small"
                            >
                                <option value={0}>{"(Seleccione)"}</option>
                                {listPlanes.map((row) => (
                                    <option key={row.idTerapiaPlan} value={row.idTerapiaPlan}>
                                        {row.participante} - {row.fechaInicio ? new Date(row.fechaInicio).toLocaleDateString("es-PE") : ""}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            {cargando && <Grid item xs={12}><Typography>Cargando...</Typography></Grid>}
            {reporte && (
                <>
                    <Grid item xs={12}>
                        <Typography variant="h5" sx={{ fontWeight: "bold", textAlign: "center" }}>
                            {reporte.titulo}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Table size="small">
                            <TableBody>
                                <TableRow><TableCell sx={{ fontWeight: "bold" }}>Nombre del usuario</TableCell><TableCell>{reporte.participante}</TableCell></TableRow>
                                <TableRow><TableCell sx={{ fontWeight: "bold" }}>Fecha de inicio del plan de terapia</TableCell><TableCell>{reporte.fechaInicio ? new Date(reporte.fechaInicio).toLocaleDateString("es-PE") : ""}</TableCell></TableRow>
                                <TableRow><TableCell sx={{ fontWeight: "bold" }}>Terapeuta</TableCell><TableCell>{reporte.terapeuta}</TableCell></TableRow>
                                <TableRow><TableCell sx={{ fontWeight: "bold" }}>Transicion Terapeutica</TableCell><TableCell>{reporte.transicionTerapeutica || ""}</TableCell></TableRow>
                                <TableRow><TableCell sx={{ fontWeight: "bold" }}>Fecha de transicion</TableCell><TableCell>{reporte.fechaTransicion ? new Date(reporte.fechaTransicion).toLocaleDateString("es-PE") : ""}</TableCell></TableRow>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", textAlign: "center", mt: 2 }}>
                            SISTEMA ANUAL DE INTERVENCIN TERAPEUTICO
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Table size="small" sx={{ border: 1 }}>
                            <TableHead>
                                {renderCabeceraMeses([1, 2, 3, 4, 5, 6])}
                            </TableHead>
                            <TableBody>
                                {renderFilaMeses([1, 2, 3, 4, 5, 6])}
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12}>
                        <Table size="small" sx={{ border: 1 }}>
                            <TableHead>
                                {renderCabeceraMeses([7, 8, 9, 10, 11, 12])}
                            </TableHead>
                            <TableBody>
                                {renderFilaMeses([7, 8, 9, 10, 11, 12])}
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: 2, whiteSpace: "pre-wrap" }}>
                            {reporte.enunciadoReporte || ""}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Table size="small" sx={{ border: 1 }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: "bold" }}>Modelo/Sistema</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Fecha de inicio</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }}>Observaciones</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(reporte.modelos || []).map((m, i) => (
                                    <TableRow key={i}>
                                        <TableCell sx={{ fontWeight: "bold" }}>{m.modelo}</TableCell>
                                        <TableCell>
                                            {(m.meses || []).map((mm, j) => (
                                                <div key={j}>
                                                    {mm.fechaPrimera ? new Date(mm.fechaPrimera).toLocaleDateString("es-PE") : ""}
                                                    {" "}({NOMBRES_MES[mm.mes] || mm.mes})
                                                </div>
                                            ))}
                                        </TableCell>
                                        <TableCell>
                                            {(m.areas || []).map((a, k) => (
                                                <div key={k} style={{ marginBottom: 8 }}>
                                                    <strong>{a.area}</strong>
                                                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                                                        {(a.detalles || []).map((d, l) => (
                                                            <li key={l}>
                                                                {d.detalle}
                                                                {d.puntuacion ? <strong> ({d.puntuacion})</strong> : ""}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ))}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </Grid>
                </>
            )}
        </Grid>
    );
};

export default Trimestral;
